import React, { useState } from "react";
import { ServicePortalRssFeedItemProps } from "./types";

const getFullCompanyName = (companyName: string) => {
  if (companyName === "Sahlgrenska Universitetssjuk") {
    return "Sahlgrenska Universitetssjukhuset";
  }

  return companyName;
};

export const ServicePortalRssFeedItem = (
  props: ServicePortalRssFeedItemProps
) => {

  const [expanded, setExpanded] = useState<boolean>(false);

  const {
    displayOption,
    item
  } = props;

  const _paq = (window._paq = window._paq || []);

  const companySpecificInfo = item.company_specific_info ?? [];

  const handleToggle = (title: string) => {
    if (expanded) {
      _paq.push(["trackEvent", "Klick visa mer driftinformation", title, document.location.href.toLowerCase()]);
    }
  }

  const handleClick = () => {
    setExpanded(expanded => !expanded);
  }

  return (
    <article className="vgr-listitem">
      {item.updated_onString && item.type !== "planned" ?
        item.updated_onString && (
          <span className="vgr-listitem__sub-heading">
            {item.updated_onString}
          </span>
        ) :
        (<></>)}

      {displayOption.tag === "OneThirdWidth" ?
      <header>
          <h3 className="vgr-listitem__heading">
            {item.message}
          </h3>
          <div className="vgr-listitem__badge-wrapper badge__shape">
            {item.type === "outage" &&
              <div className="vgr-badge vgr-badge--error">
                Avbrott
              </div>
            }
            {item.type === "degradation" &&
              <div className="vgr-badge vgr-badge--warning">
                Störning
              </div>
            }
            {item.type === "planned" &&
              <div className="vgr-badge vgr-badge--info">
                Planerat arbete
              </div>
            }
          </div>
      </header> :
      <header>
          <h3 className="vgr-listitem__heading">
            {item.message}
          </h3>
          <div className="vgr-listitem__badge-wrapper">
            {item.type === "outage" &&
              <div className="vgr-badge vgr-badge--error">
                Avbrott
              </div>
            }
            {item.type === "degradation" &&
              <div className="vgr-badge vgr-badge--warning">
                Störning
              </div>
            }
            {item.type === "planned" &&
              <div className="vgr-badge vgr-badge--info">
                Planerat arbete
              </div>
            }
          </div>
      </header>
      }
      {item.beginString && item.type === "planned" && (
        <h4 className="vgr-listitem__sub-heading start-string">
          <p>Startar:</p> {item.beginString}
        </h4>
      )
      }
      {item.endString && item.type === "planned" &&
        <h4 className="vgr-listitem__sub-heading end-string">
          <p>Slutar:</p> {item.endString}
        </h4>

      }
      <div className="vgr-listitem__body">
        <details onToggle={(e) => handleToggle(item.message)} className="vgr-serviceportal-feed__details">
          <summary onClick={handleClick} className="vgr-serviceportal-feed__details-expand" data-expanded={expanded}>
            {expanded ?
              <div className="vgr-serviceportal-feed__chevron-wrapper open" aria-label={"Visa mindre innehåll om " + item.message}>Visa mindre innehåll
                <svg height="14" width="14">
                  <use href={props.svgArrow} />
                </svg>
              </div>
              :
              <div className="vgr-serviceportal-feed__chevron-wrapper" aria-label={"Visa mer innehåll om " + item.message}>Visa mer innehåll
                <svg height="14" width="14">
                  <use href={props.svgArrow} />
                </svg>
              </div>
            }
          </summary>
          <div className="vgr-serviceportal-feed__details-body">
            {item.details != null &&
              <div className="vgr-serviceportal-feed__details-text" dangerouslySetInnerHTML={{ __html: item.details }} />
            }
            {item.attachments.length !== 0 &&
              <div className="vgr-serviceportal-feed__details-attachments">
                <strong>Bifogade filer</strong>
                {item.attachments.map((attachment) => (
                  <div key={attachment.name} className="vgr-serviceportal-feed__details-attachment">
                    <svg height="14" width="14">
                      <use href={props.svgAttachment} />
                    </svg>
                    <a href={attachment.link}>{attachment.name}</a>
                  </div>
                ))}
              </div>
            }
            {companySpecificInfo.length !== 0 && (
              <div className="vgr-serviceportal-feed__details-company-info">
                {companySpecificInfo.map((info, index) => {
                  const fullCompanyName = getFullCompanyName(info.company);

                  return (
                    <div key={`${info.company}-${index}`} className="vgr-serviceportal-feed__details-company">
                      <h4 className="vgr-serviceportal-feed__details-company-name">För oss på {fullCompanyName}</h4>
                      {info.information && (
                        <div
                          className="vgr-serviceportal-feed__details-text"
                          dangerouslySetInnerHTML={{ __html: info.information }}
                        />
                      )}
                      {info.attachments.length !== 0 && (
                        <div className="vgr-serviceportal-feed__details-attachments vgr-serviceportal-feed__details-attachments--company-info">
                          <strong>Bifogade filer</strong>
                          {info.attachments.map((infoAttachment) => (
                            <div key={infoAttachment.name} className="vgr-serviceportal-feed__details-attachment">
                              <svg height="14" width="14">
                                <use href={props.svgAttachment} />
                              </svg>
                              <a href={infoAttachment.link}>{infoAttachment.name}</a>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
            <div className="vgr-serviceportal-feed__details-text">
              <ul>
                <li>
                  <a href={item.link_to_plexus}>Visa driftinformation för tjänsten i VGR serviceportal</a>
                </li>
                <li>
                  <a href={item.link_to_plexus}>Prenumerera på driftinformation för tjänsten via e-post</a>
                </li>
              </ul>
            </div>
          </div>
        </details>
      </div>
    </article>
  );
};
